/* eslint no-bitwise: ["error", { "allow": ["<<"] }] */

import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Image from '../../../shared/components/Image';

const generateHash = (string = '') => {
    let hash = 5381;
    for (let i = 0; i < string.length; i += 1) {
        const charCode = string.charCodeAt(i);
        hash = (hash << 5) + hash + charCode;
    }
    return hash;
};

const generateCertificateColorCode = (string) => {
    const hash = generateHash(string);
    return Math.abs(hash % 10) + 1;
};

const CertificateImageWidget = (props) => {
    const { id, imageUrl, fontAwesomeIcon, className, onClick = () => {}, label = '', dimension } = props;
    const colorNumber = generateCertificateColorCode(id);
    return (
        <div className={cns('certificate-image', className)} onClick={onClick}>
            <div className={'image-container'}>
                <Image
                    key={id}
                    src={imageUrl}
                    dimension={dimension || { h: 128, w: 174 }}
                    cloudinaryCrop={'fill'}
                    radius={'5'}
                />
                <div className={cns('image-overlay', `avatar-color-${colorNumber}`)} />
                <span className={`certificate-icon-image fal fa-${fontAwesomeIcon}`} />
            </div>
            {label && <h4>{label}</h4>}
        </div>
    );
};

CertificateImageWidget.propTypes = {
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    fontAwesomeIcon: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    label: PropTypes.string,
    dimension: PropTypes.object
};

export default CertificateImageWidget;
